import { ConnectingAirportsOutlined } from "@mui/icons-material";
import {
  LOADING_DATA,
  LOADING_UI,
  STOP_LOADING_UI,
  SET_ERRORS,
  CLEAR_ERRORS,
  SET_GENERATED_URL,
  SET_PINTEREST_BOARDS,
  SET_SELECTED_BOARDS,
  SET_DRAGGED_MEDIA,
  SET_AFFILIATE_DATA,
  SET_WISE_TAG,
  STOP_LOADING_DATA,
  SET_ALL_POST_URLS,
  SET_USED_SITE_MAP,
  SET_SHOP_LISTINGS,
  UPDATE_LISTING,
  SET_SHOP_PROFILES,
  SET_IS_BULK_SCHEDULING,
  ADD_BOARD,
  SET_BOARD_SECTIONS,
  SET_PRICING_PARITY,
  SET_NEW_TREND_ALERT_SETTINGS,
  UPDATE_NEW_TREND_ALERT_SETTINGS,
  SET_USER_TREND_ALERTS,
  SET_RSS_FEEDS,
  SET_DESIGN_SETTINGS,
  SET_ACTIVE_CATALOG,
  SET_ALL_CATALOGS,
  DELETE_CATALOG,
  ADD_CATALOG,
  UPDATE_CATALOG,
  SET_CATALOG_ITEMS,
  DELETE_CATALOG_ITEM_IMAGE,
  ADD_CATALOG_ITEM_IMAGE,
  UPDATE_CATALOG_ITEM,
  DELETE_CATALOG_ITEM,
} from "../types";

import axios from "axios";

export const clearErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};

export const setErrors = (errors) => (dispatch) => {
  dispatch({ type: SET_ERRORS, payload: errors });
};

export const setGeneratedURL = (url) => (dispatch) => {
  dispatch({ type: SET_GENERATED_URL, payload: url });
};

export const getAllPinterestBoards = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/pinterestAPI/getAllUserPinterestBoards", {
        // No access_token needed - backend fetches from database
      })
      .then((res) => {
        dispatch({
          type: SET_PINTEREST_BOARDS,
          payload: res.data,
        });

        resolve();
      })
      .catch((err) => {
        dispatch({
          type: SET_PINTEREST_BOARDS,
          payload: [],
        });

        console.error("Unable to get all Pinterest boards: ", err);
        reject("Unable to get all Pinterest boards");
      });
  });
};

export const getBoardSections = (boardId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/pinterestAPI/getBoardSections", {
        // No access_token needed - backend fetches from database
        boardId,
      })
      .then((res) => {
        dispatch({
          type: SET_BOARD_SECTIONS,
          payload: { boardId, sections: res.data.items },
        });
        resolve();
      })
      .catch((err) => {
        console.error("Unable to get the board sections: ", err);
        reject("Unable to get the board sections.");
      });
  });
};

export const setSelectedBoards = (board) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_BOARDS,
    payload: board,
  });
};

export const createPinterestBoard =
  (boardName, boardCategory, boardDescription) => (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/pinterestAPI/createPinterestBoard", {
          // No access_token needed - backend fetches from database
          boardName,
          boardCategory,
          boardDescription,
        })
        .then((res) => {
          dispatch({
            type: ADD_BOARD,
            payload: res.data,
          });

          resolve(res.data);
        })
        .catch((err) => {
          console.error("Unable to create Pinterest board: ", err);
          reject(err.response.data);
        });
    });
  };

export const setDraggedMedia = (draggedMedia) => (dispatch) => {
  dispatch({
    type: SET_DRAGGED_MEDIA,
    payload: draggedMedia,
  });
};

export const incrementAffiliateClicks = (affiliateID) => (dispatch) => {
  axios
    .post("/api/affiliate/incrementAffiliateClicks", {
      affiliateID,
    })
    .catch((err) => {
      console.error("Unable to increment affiliate clicks: ", err);
    });
};

export const recordAffiliateSale = (saleDetails) => (dispatch) => {
  axios
    .post("/api/affiliate/recordAffiliateSale", saleDetails)
    .then(() => {
      console.log("Affiliate sale recorded successfully");
    })
    .catch((err) => {
      console.error("Error while recording an affiliate sale", err);
    });
};

export const getAffiliateData = () => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  axios
    .get("/api/affiliate/getAffiliateData")
    .then((res) => {
      dispatch({ type: SET_AFFILIATE_DATA, payload: res.data });
    })
    .catch((err) => {
      dispatch({
        type: STOP_LOADING_DATA,
      });
    });
};

export const setUserAffiliateID = (affiliateID) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  axios
    .post("/api/affiliate/setUserAffiliateID", { affiliateID })
    .then((res) => {
      dispatch(getAffiliateData());
    })
    .catch((err) => {
      console.error("Error setting affiliate data: ", err);

      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
      dispatch({
        type: STOP_LOADING_DATA,
      });
    });
};

export const saveWiseTag = (wiseTag, closeDialog) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  axios
    .post("/api/affiliate/saveWiseTag", { wiseTag })
    .then((res) => {
      console.log("Saved Wise tag email address successully.");
      dispatch({ type: SET_WISE_TAG, payload: wiseTag });
      dispatch({ type: CLEAR_ERRORS });
    })
    .catch((err) => {
      console.error("Error saving WiseTag: ", err);

      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

// Founding Partners actions
export const validateFoundingPartnerInvite = (email) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  return new Promise((resolve, reject) => {
    axios
      .post("/api/foundingPartners/validateInvite", { email })
      .then((res) => {
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: STOP_LOADING_DATA });
        resolve(res.data);
      })
      .catch((err) => {
        console.error("Error validating founding partner invite: ", err);
        const errorMessage =
          err.response?.data?.error || "Error validating invite";
        dispatch({
          type: SET_ERRORS,
          payload: { general: errorMessage },
        });
        dispatch({ type: STOP_LOADING_DATA });
        reject(errorMessage);
      });
  });
};

export const checkFoundingPartnerUser = (inviteEmail) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/foundingPartners/checkUser", { inviteEmail })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.error("Error checking founding partner user: ", err);
        reject(err.response?.data?.error || "Error checking user status");
      });
  });
};

export const setFoundingPartnerAffiliateID =
  (affiliateID, inviteEmail) => (dispatch) => {
    dispatch({ type: LOADING_DATA });
    return new Promise((resolve, reject) => {
      axios
        .post("/api/foundingPartners/setAffiliateID", {
          affiliateID,
          inviteEmail,
        })
        .then((res) => {
          dispatch({ type: CLEAR_ERRORS });
          dispatch({ type: STOP_LOADING_DATA });
          resolve(res.data);
        })
        .catch((err) => {
          console.error("Error setting founding partner affiliate ID: ", err);
          dispatch({
            type: SET_ERRORS,
            payload: err.response?.data || { general: "Error registering" },
          });
          dispatch({ type: STOP_LOADING_DATA });
          reject(err.response?.data);
        });
    });
  };

// Upgrade existing affiliate to founding partner
export const upgradeToFoundingPartner = (inviteEmail) => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  return new Promise((resolve, reject) => {
    axios
      .post("/api/foundingPartners/upgradeAffiliate", { inviteEmail })
      .then((res) => {
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: STOP_LOADING_DATA });
        resolve(res.data);
      })
      .catch((err) => {
        console.error("Error upgrading to founding partner: ", err);
        dispatch({
          type: SET_ERRORS,
          payload: err.response?.data || { general: "Error upgrading account" },
        });
        dispatch({ type: STOP_LOADING_DATA });
        reject(err.response?.data);
      });
  });
};

export const getFoundingPartnerData = () => (dispatch) => {
  dispatch({ type: LOADING_DATA });
  return new Promise((resolve, reject) => {
    axios
      .get("/api/foundingPartners/getData")
      .then((res) => {
        dispatch({ type: SET_AFFILIATE_DATA, payload: res.data });
        dispatch({ type: STOP_LOADING_DATA });
        resolve(res.data);
      })
      .catch((err) => {
        console.error("Error getting founding partner data: ", err);
        dispatch({ type: STOP_LOADING_DATA });
        reject(err);
      });
  });
};

export const updateFoundingPartnerProfile = (profileData) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  return new Promise((resolve, reject) => {
    axios
      .put("/api/foundingPartners/updateProfile", profileData)
      .then((res) => {
        dispatch({ type: CLEAR_ERRORS });
        // Refresh the founding partner data
        return dispatch(getFoundingPartnerData());
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        console.error("Error updating founding partner profile: ", err);
        dispatch({
          type: SET_ERRORS,
          payload: err.response?.data || { error: "Error updating profile" },
        });
        reject(err);
      });
  });
};

export const setAllPostURLs = (postsArray) => (dispatch) => {
  dispatch({ type: SET_ALL_POST_URLS, payload: postsArray });
};

export const setUsedSitemap = (sitemap) => (dispatch) => {
  dispatch({ type: SET_USED_SITE_MAP, payload: sitemap });
};

export const getShopListings =
  (
    activeShop,
    pageNumber,
    searchInput = null,
    productStatus = "all",
    paginationLink
  ) =>
  (dispatch) => {
    if (activeShop) {
      dispatch({ type: LOADING_DATA });

      // Optional parameters
      if (searchInput === undefined) {
        searchInput = null;
      }
      if (paginationLink === undefined) {
        paginationLink = null;
      }

      if (activeShop.shopType == "Etsy") {
        axios
          .get("/api/etsyAPI/getEtsyShopListings", {
            params: {
              shopID: activeShop.id,
              pageNumber,
              searchInput,
            },
          })
          .then((res) => {
            dispatch({ type: SET_SHOP_LISTINGS, payload: res.data });
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
              type: STOP_LOADING_DATA,
            });
          })
          .catch((err) => {
            console.error("Unable to get Etsy shop listings: ", err);

            dispatch({ type: SET_SHOP_LISTINGS, payload: [] });
            dispatch({
              type: SET_ERRORS,
              payload: `Unable to get Etsy shop listings: ${err}`,
            });
            dispatch({
              type: STOP_LOADING_DATA,
            });
          });
      } else if (activeShop.shopType == "Shopify") {
        axios
          .get("/api/shopifyAPI/getShopifyShopListings", {
            params: {
              shopID: activeShop.id,
              searchInput,
              paginationLink,
              productStatus,
            },
          })
          .then((res) => {
            dispatch({ type: SET_SHOP_LISTINGS, payload: res.data });
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
              type: STOP_LOADING_DATA,
            });
          })
          .catch((err) => {
            console.log(err);
            let errorMessage = `Unable to get Shopify shop listings: ${err}`;

            if (err.response && err.response.status == 401) {
              errorMessage = `Unable to get Shopify shop listings: Please reconnect your store.`;
            }

            console.error("Unable to get Shopify shop listings: ", err);
            dispatch({ type: SET_SHOP_LISTINGS, payload: [] });

            dispatch({
              type: SET_ERRORS,
              payload: errorMessage,
            });
            dispatch({
              type: STOP_LOADING_DATA,
            });
          });
      } else if (activeShop.shopType == "WooCommerce") {
        axios
          .get("/api/woocommerce/products", {
            params: {
              shopID: activeShop.id,
              pageNumber,
              searchInput,
            },
          })
          .then((res) => {
            dispatch({ type: SET_SHOP_LISTINGS, payload: res.data });
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
              type: STOP_LOADING_DATA,
            });
          })
          .catch((err) => {
            console.error("Unable to get WooCommerce shop listings: ", err);
            const errorMessage =
              err.response?.data?.error ||
              err.response?.data?.message ||
              err.message;

            dispatch({ type: SET_SHOP_LISTINGS, payload: [] });
            dispatch({
              type: SET_ERRORS,
              payload: `Unable to get WooCommerce shop listings: ${errorMessage}`,
            });
            dispatch({
              type: STOP_LOADING_DATA,
            });
          });
      }
    } else {
      // No active shop
      dispatch({
        type: SET_SHOP_LISTINGS,
        payload: { count: 0, listings: [] },
      });
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: STOP_LOADING_DATA,
      });
    }
  };

export const getShopifyShopListingsFromAccessToken =
  (accessToken, shopName) => (dispatch) => {
    axios
      .get("/api/shopifyAPI/getShopifyShopListingsFromAccessToken", {
        params: {
          accessToken,
          shopName,
        },
      })
      .then((res) => {
        dispatch({ type: SET_SHOP_LISTINGS, payload: res.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({
          type: STOP_LOADING_DATA,
        });
      })
      .catch((err) => {
        console.error("Unable to get shop listings: ", err);
        dispatch({
          type: SET_ERRORS,
          payload: `Unable to get shop listings: ${err}`,
        });
        dispatch({
          type: STOP_LOADING_DATA,
        });
      });
  };

export const setShopListings = (listings) => (dispatch) => {
  dispatch({
    type: SET_SHOP_LISTINGS,
    payload: { count: listings.length, listings: listings },
  });
};

export const updateListing = (listing) => (dispatch) => {
  dispatch({ type: UPDATE_LISTING, payload: { listing } });
};

export const activateShopProfile = (shop) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/etsyAPI/activateShopProfile", { shopID: shop.id })
      .then((shopProfilesRes) => {
        let shopProfiles = shopProfilesRes.data;

        // Set all shop profiles
        dispatch({ type: SET_SHOP_PROFILES, payload: shopProfiles });
        dispatch(getShopListings(shop, 1));
        resolve();
      })
      .catch((err) => {
        console.error(`Unable to activate shop profile: ${err}`);
        reject(err);
      });
  });
};

export const setIsBulkScheduling = (isBulkScheduling) => (dispatch) => {
  dispatch({ type: SET_IS_BULK_SCHEDULING, payload: isBulkScheduling });
};

export const loadPricingParityData = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    let countryData;
    let countryIsoCode;

    // Create clean version of axios without common Auth header
    var cleanAxios = axios.create();
    cleanAxios.defaults.headers.common = {};

    cleanAxios
      .get(
        "https://api.geoapify.com/v1/ipinfo?&apiKey=562e3e0fa97c435f84c2c1b102c6f230",
        {}
      )
      .then((response) => {
        // Set the country code
        countryData = response.data;
        countryIsoCode = response.data.country.iso_code;

        return axios.get(`/api/pricingParity/${countryIsoCode}`);
      })
      .then((res) => {
        dispatch({
          type: SET_PRICING_PARITY,
          payload: {
            countryCode: countryIsoCode,
            percentageAdjustment: res.data,
          },
        });

        resolve();
      })
      .catch((error) => {
        console.log("Failed to get pricing parity: ", error);
        console.log(error);

        resolve(); // We resolve this and the user will see the default pricing
      });
  });
};

export const setPricingParity = (pricingParity) => (dispatch) => {
  dispatch({ type: SET_PRICING_PARITY, payload: pricingParity });
};

export const deactivateAllShopProfiles = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/etsyAPI/deactivateAllShopProfiles")
      .then((newShopsRes) => {
        // Set all shop profiles
        dispatch({ type: SET_SHOP_PROFILES, payload: newShopsRes.data });
        resolve();
      })
      .catch((err) => {
        console.error(`Unable to deactivate all shop profiles: ${err}`);
        reject(err);
      });
  });
};
